//import FbSwiper from '../util/Swiper';
import ImageZoom from 'js-image-zoom';

const { $ } = window

function handleIntersectionObserver() {
   // Check if the target element is above the current scroll position
   function isElementAboveScroll(element) {
      const elementRect = element.getBoundingClientRect()
      return elementRect.top < window.scrollY
   }

   let callback = (entries, observer) => {
      entries.forEach((entry) => {
         if (entry.isIntersecting || isElementAboveScroll(entry.target)) {
            let target = entry.target
            target.classList.remove('ioHidden')
            target.classList.add('ioFadeIn')
            observer.unobserve(target)
         }
      })
   }

   let options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.25,
   }

   let observer = new IntersectionObserver(callback, options)

   const $targets = $(
      '.ioHidden'
   )
   if ($targets.length) {
      $targets.each((_, el) => {
         setTimeout(function () {
            observer.observe(el)
         }, 500)
      })
   }
}

function handleMobileMenu() {
   const $body = $('body')
   const $toggleNav = $('.toggle-nav')
   const $navSiteHeader = $('.navigation--site-header')
   $toggleNav.on('click', function () {
      $body.toggleClass('menu-open')
      $navSiteHeader.toggleClass('menu-open')
   })
}
function hideMobileMenu(x) {
   const $body = $('body')
   const $toggleNav = $('.toggle-nav')
   const $navSiteHeader = $('.navigation--site-header')
   if (x.matches) {
      $body.removeClass('menu-open')
      $navSiteHeader.removeClass('menu-open')
   }
}

function handleNewsAjaxLoadMore() {
   const $loadMoreBtn = $('.btn--load-more')
   if (!$loadMoreBtn.length) {
      return
   }

   $loadMoreBtn.on('click', function (e) {
      e.preventDefault()

      const $button = $(this)
      const data = {
         action: 'loadmore',
         query: loadMoreParams.posts,
         page: loadMoreParams.current_page
      }

      $.ajax({
         url: loadMoreParams.ajaxurl,
         data: data,
         type: 'POST',
         beforeSend: function (xhr) {
            $button.find('span').text('Loading...')
         },
         success: function (data) {
            if (data) {
               $button.find('span').text('Load More')
               $('.news--grid').append(data)
               loadMoreParams.current_page++

               if (
                  loadMoreParams.current_page ==
                  loadMoreParams.max_page
               ) {
                  $button.remove() // if last page, remove the button
               }
            } else {
               $button.remove() // if no data, remove the button as well
            }
         },
      })
   })
   //})
}

function handleProductPreviewer() {
   const $productPreviewer = $('section.products')
   const $names = $('.active--name h3')
   const $buttons = $('section.products button')
   const $images = $('.products--images img')

   if (!$productPreviewer.length) return

   let activeIdx = 0,
      clickedIdx = activeIdx
   $buttons[activeIdx].classList.add('active')
   $images[activeIdx].classList.add('active')
   $names.eq(activeIdx).addClass('active').show().siblings('h3').hide()
   $buttons.on('click', function () {
      // get active index
      clickedIdx = $buttons.index(this)

      // if not same as current
      if (clickedIdx === activeIdx) {
         return
      }

      activeIdx = clickedIdx
      const $btn = $buttons.eq(activeIdx)
      const $img = $images.eq(activeIdx)
      const $name = $names.eq(activeIdx)

      // adjust visibility
      $name.addClass('active').show()
      $name.siblings('.active').removeClass('active').hide()
      $btn.addClass('active')
      $btn.siblings('.active').removeClass('active')
      $img.addClass('active')
      $img.siblings('.active').removeClass('active')
   })
}

function handleProductDetail() {
   // Check for product details block
   const productDetailBlocks = $('.product-detail');
   if (!productDetailBlocks.length) {
      return
   }

   let product_details = productDetailBlocks;
   
   // Function to set the max height of the gallery equal to the height of the image block
   function setGalleryHeight() {
      if (window.innerWidth >= 1024) {
         if ($('.product-detail__gallery')) {
            let maxHeight = $('.product-detail__image').outerHeight();
            $('.product-detail__gallery').css('max-height', maxHeight);
         }
      }
   }

   // set gallery height
   setGalleryHeight();

   // make thumbnails clickable to switch out for main image
   if (product_details.length) {
      product_details.each(function(index, el) {
         let product_gallery_items = $(product_details[index]).find('.product-detail__gallery-item');
         if (product_gallery_items.length) {
            product_gallery_items.each(function(ind, ele) {
               $(product_gallery_items[ind]).on('click', function() {
                  product_details.find('.product-detail__gallery-item-active').removeClass('product-detail__gallery-item-active');
                  let this_image = $(product_gallery_items[ind]).find('img').data('full-image');
                     $(this).addClass('product-detail__gallery-item-active');
                     console.log('here');
                     $(product_details[index]).find('.product-detail__image img').attr('srcset', '').attr('src', this_image);
                  })
               })
         }
      })
   }

   let product_images = $('.product-detail__image');
   let zooms = [];

   function handleMouseEnter() {
      let this_width = $(this).outerWidth();
      let this_height = $(this).outerHeight();
      let options = {
         width: this_width,
         //height: this_height,
         offset: {
            horizontal: this_width * -1
         },
      }
      let this_zoom = new ImageZoom(this, options);
      zooms.push(this_zoom);
   }
   function addHoverEffect() {
      product_images.each(function(index, el) {
         $(product_images[index]).on('mouseenter', handleMouseEnter)
      })
   }

   /* kill the hover effect on resize to prevent bug with image position */
   function clearHoverEffect() {
      product_images.each(function(index, el) {
         $(product_images[index]).off('mouseenter', handleMouseEnter);
         for (let i = 0; i < zooms.length; zooms++) {
            zooms[i].kill();
         }
         zooms = [];
         $('.js-image-zoom__zoomed-image').remove();
         if (window.innerWidth > 1024) {
            setTimeout(function() {
               addHoverEffect();
            }, 50);
         }
      });
   }
   
   // add hover effect
   if (window.innerWidth > 1024) {
      addHoverEffect();
   }

   // set gallery height on resize
   $(window).on('resize', function() {
      if (window.innerWidth > 1024) {
         setGalleryHeight();
         clearHoverEffect();
      } else {
         clearHoverEffect();
      }
   })
}

function recalc() {
   let navHeight = $('.site-header').outerHeight()
   if (document.body.classList.contains('logged-in')) {
      if (window.innerWidth < 782) {
         navHeight += 46
      } else {
         navHeight += 32
      }
   }

   document
      .querySelector(':root')
      .style.setProperty('--navbar-height', navHeight + 'px')
}


/**
 * Run blocks
 *
 */
function runBlocks() {

   console.log('runBlocks')
   // News
   handleNewsAjaxLoadMore()

   // Products
   handleProductPreviewer()

   // Product Detail
   handleProductDetail()
}

/*** Exports
 *
 */
export {
   handleIntersectionObserver,
   handleMobileMenu,
   hideMobileMenu,
   // handleNewsLoadMore,
   recalc,
   runBlocks,
}
